module.exports = __webpack_public_path__ + "static/media/pagination-first-disabled.c9603a4a.svg";